import EppoVariant from '$lib/storyblok/blocks/eppoVariant.svelte';
import SbButton from '$lib/storyblok/blocks/sbButton.svelte';
import MuxSbVideo from '$lib/storyblok/blocks/muxSbVideo.svelte';
import ContentSection from '$lib/storyblok/blocks/contentSection.svelte';
import PageSpacer from '$lib/storyblok/blocks/pageSpacer.svelte';
import HeroVideo from '$lib/storyblok/blocks/heroVideo.svelte';
import ReviewTeaser from '$lib/storyblok/blocks/reviewTeaser.svelte';
import RichtText from '$lib/storyblok/blocks/richtextBlock.svelte';
import Center from '$lib/storyblok/blocks/center.svelte';
import Margin from '$lib/storyblok/blocks/margin.svelte';
import Image from '$lib/storyblok/blocks/imageBlock.svelte';
import TypeformContainer from '$lib/storyblok/blocks/typeformContainer.svelte';
import CtaModule from '$lib/storyblok/blocks/ctaModule.svelte';
import SlideInTransition from './blocks/slideInTransition.svelte';
import PageGrid from '$lib/storyblok/blocks/pageGridBlock.svelte';
import YotpoReviewsRating from './blocks/yotpoReviewsRating.svelte';
import HeroModule from './blocks/heroModule.svelte';
import HeroModuleV2 from './blocks/heroModuleV2.svelte';
import GenericText from './blocks/genericText.svelte';
import ReferralCard from '$lib/storyblok/blocks/referralCard.svelte';
import EmailCaptureEmbed from '$lib/storyblok/blocks/emailCaptureEmbed.svelte';
import Carousel from '$lib/storyblok/blocks/sbCarousel.svelte';
import GeolocationBlock from '$lib/storyblok/blocks/geolocationBlock.svelte';
import LandingPageRiverModule from '$lib/storyblok/blocks/landingPageRiverModule.svelte';
import SiteBanner from './blocks/siteBanner.svelte';
import CtaBanner from './blocks/ctaBanner.svelte';
import ValuePropGrid from './blocks/valuePropGrid.svelte';
import CartValueProps from './blocks/cartValueProps.svelte';
import PageFilter from './blocks/pageFilter.svelte';
import VerifiedReviews from './blocks/verifiedReviews.svelte';
import EditorialSpotlight from './blocks/editorialSpotlight.svelte';
import SpotlightQuote from './blocks/spotlightQuote.svelte';
import HighlightSlideshow from './blocks/highlightSlideshow.svelte';
import HighlightSlideshowItem from './blocks/highlightSlideshowItem.svelte';
import ProductBanner from './blocks/productBanner.svelte';
import ValueProp from './blocks/valueProp.svelte';
import ButtonV3 from './blocks/buttonV3.svelte';
import PageGrid16 from './blocks/pageGrid16Block.svelte';
import ResponsiveMuxVideo from './blocks/responsiveMuxVideo.svelte';
import TypeformCtaModule from './blocks/typeformCtaModule.svelte';
import CustomerReviews from './blocks/homepage/customerReviews.svelte';
import type { StoryblokComponent } from './sdk';
import AwardBanner from './blocks/awardBanner.svelte';
import BenefitsBento from './blocks/bento/benefitsBento.svelte';
import BentoInfoCard from './blocks/bento/bentoInfoCard.svelte';
import TextSplit from './blocks/textSplit.svelte';
import ProductCtaModule from './blocks/productCtaModule.svelte';
import SimpleImageBlock from './blocks/simpleImageBlock.svelte';
import AssetBlock from './blocks/assetBlock.svelte';
import FullbleedGallery from './blocks/fullbleedGallery.svelte';
import HeroFullbleed from './blocks/heroFullbleed.svelte';
import HeroFloatingVideo from './blocks/heroFloatingVideo.svelte';
import HeroSideBySide from './blocks/heroSideBySide.svelte';
import HeroPressBanner from './blocks/heroPressBanner.svelte';
import HeroPressBannerItem from './blocks/heroPressBannerItem.svelte';
import HeroSideBySideStacked from './blocks/heroSideBySideStacked.svelte';
import ButtonHeroPrimary from './blocks/buttonHeroPrimary.svelte';
import ButtonHeroSecondary from './blocks/buttonHeroSecondary.svelte';
import LocalOfferHero from './blocks/localOffer/localOfferHero.svelte';
import QuoteCarousel from './blocks/homepage/quoteCarousel.svelte';
import QuoteCarouselItem from './blocks/homepage/quoteCarouselItem.svelte';
import PartnerSpotlight from './blocks/localOffer/partnerSpotlight.svelte';
import LocalImpact from './blocks/localOffer/localImpact.svelte';
import LocalOfferEntry from './blocks/localOffer/localOfferEntry.svelte';
import NoLocalOfferModal from './blocks/localOffer/noLocalOfferModal.svelte';
import GeneralImpact from './blocks/localOffer/generalImpact.svelte';
import PayAsYouThrow from './blocks/localOffer/payAsYouThrow.svelte';
import WasteEducation from './blocks/localOffer/wasteEducation.svelte';
import SimpleLink from './blocks/simpleLink.svelte';
import CustomPaymentMessagingElement from './blocks/customPaymentMessagingElement.svelte';
import HowItWorksSimple from './blocks/howItWorksSimple.svelte';
import HowItWorksSimpleItem from './blocks/howItWorksSimpleItem.svelte';
import LatestStories from './blocks/homepage/latestStories.svelte';
import AddToCartButton from './blocks/cart/addToCartButton.svelte';
import InlineProductSelector from './blocks/cart/inlineProductSelector.svelte';
import NavigationExpand from './blocks/navigation/navigationExpand.svelte';
import NavLinkHighlight from './blocks/navigation/navLinkHighlight.svelte';
import NavLinkStandard from './blocks/navigation/navLinkStandard.svelte';
import NavTeaserCard from './blocks/navigation/navTeaserCard.svelte';
import NavMenuBarLink from './blocks/navigation/navMenuBarLink.svelte';
import ProductSelector from './blocks/productSelect/productSelector.svelte';
import ProductSelectorItem from './parts/productSelectorItem.svelte';
import ActiveProductWrapper from './blocks/productSelect/activeProductWrapper.svelte';
import ActiveProductSubline from './blocks/productSelect/activeProductSubline.svelte';
import CartConfiguration from './blocks/cart/cartConfiguration.svelte';
import BenefitsBox from './blocks/benefitsBox.svelte';
import BenefitsBoxItem from '$lib/storyblok/blocks/benefitsBoxItem.svelte';
import Anchor from './blocks/anchor.svelte';
import OnlyLogoBanner from './blocks/onlyLogoBanner.svelte';
import FeatureContainer from './blocks/featureContainer.svelte';
import CompetitorTable from './blocks/competitorTable.svelte';
import HeroHeadlineRotation from './blocks/heroHeadlineRotation.svelte';
import AccordionGallery from './blocks/boats/accordionGallery.svelte';
import AccordionGalleryCard from '$lib/storyblok/blocks/boats/accordionGalleryCard.svelte';
import FullbleedAsset from './blocks/fullbleedAsset.svelte';
import DynamicStats from './blocks/dynamicStats.svelte';
import ImageCtaBanner from './blocks/imageCtaBanner.svelte';
import RatingsIntro from './blocks/ratingsIntro.svelte';
import WallOfLoveExtended from './blocks/wallOfLoveExtended.svelte';
import InstagramVideoCard from './blocks/wallOfLove/instagramVideoCard.svelte';

export default {
	anchor: Anchor,
	product_details: import('$lib/storyblok/blocks/cart/productDetails.svelte'),
	product_checklist_item_collection: import(
		'$lib/storyblok/blocks/cart/productChecklistItemCollection.svelte'
	),
	cart_configuration: CartConfiguration,
	cart_addon: import('$lib/storyblok/blocks/cart/cartAddon.svelte'),
	cart_product_addon: import('$lib/storyblok/blocks/cart/cartProductAddon.svelte'),
	add_to_cart_button: AddToCartButton,
	inline_product_selector: InlineProductSelector,
	hero_module: HeroModule,
	hero_headline_rotation: HeroHeadlineRotation,
	hero_module_v2: HeroModuleV2,
	eppo_variant: EppoVariant,
	page_filter: PageFilter,
	sb_button: SbButton, // deprecated
	button_v3: ButtonV3,
	content_section: ContentSection,
	mux_video: MuxSbVideo,
	responsive_mux_video: ResponsiveMuxVideo,
	image: Image,
	asset: AssetBlock,
	simple_image: SimpleImageBlock,
	page_spacer: PageSpacer,
	hero_video: HeroVideo,
	slide_in_transition: SlideInTransition,
	sub_navigation: import('$lib/storyblok/blocks/navigation/subNavigation.svelte'),
	labeled_icon: import('$lib/storyblok/blocks/labeledIcon.svelte'),
	labeled_image: import('$lib/storyblok/blocks/labeledImage.svelte'),
	labeled_video: import('$lib/storyblok/blocks/labeledVideo.svelte'),
	labeled_image_carousel: import('$lib/storyblok/blocks/labeledImageCarousel.svelte'),
	quiz_modal: import('$lib/storyblok/blocks/quiz/quizModal.svelte'),
	email_capture_modal: import('$lib/storyblok/blocks/emailCaptureModal.svelte'),
	email_capture_modal_v2: import('$lib/storyblok/blocks/emailCaptureModalV2.svelte'),
	email_capture_entry_point: import('$lib/storyblok/blocks/emailCaptureEntryPoint.svelte'),
	email_capture_embed: EmailCaptureEmbed,
	flex_box: import('$lib/storyblok/blocks/sbFlexBox.svelte'),
	background_image: import('$lib/storyblok/blocks/backgroundImage.svelte'),
	center: Center,
	margin: Margin,
	corner: import('$lib/storyblok/blocks/corner.svelte'),
	overlay_link: import('$lib/storyblok/blocks/overlayLink.svelte'),
	overlay_button: import('$lib/storyblok/blocks/overlayButton.svelte'),
	richtext_block: RichtText,
	carousel: Carousel,
	carousel_indicator: import('$lib/storyblok/blocks/carouselIndicator.svelte'),
	typeform_container: TypeformContainer,
	typeform_cta_module: TypeformCtaModule,
	review_teaser: ReviewTeaser,
	yotpo_reviews_widget: import('$lib/storyblok/blocks/yotpoReviewsWidget.svelte'),
	tech_info: import('$lib/storyblok/blocks/techInfo.svelte'),
	press_banner: import('$lib/storyblok/blocks/pressBanner.svelte'),
	press_banner_quote: import('$lib/storyblok/blocks/pressBannerQuote.svelte'),
	page_grid: PageGrid, // kind of deprecated
	page_grid_16: PageGrid16,
	grid: import('$lib/storyblok/blocks/sbGrid.svelte'),
	sticky_footer: import('$lib/storyblok/blocks/stickyFooter.svelte'),
	grid_span: import('$lib/storyblok/blocks/gridSpan.svelte'),
	info_card: import('$lib/storyblok/blocks/infoCard.svelte'),
	savings_calculator_banner: import('$lib/storyblok/blocks/savingCalculatorBanner.svelte'),
	only_logo_banner: OnlyLogoBanner,
	logo_quotes_banner: import('$lib/storyblok/blocks/logoQuotesBanner.svelte'),
	logo_quote: import('$lib/storyblok/blocks/logoQuote.svelte'),
	learn_more_slider: import('$lib/storyblok/blocks/learnMoreSlider.svelte'),
	learn_more_card: import('$lib/storyblok/blocks/learnMoreCard.svelte'),
	fullscreen_video_link: import('$lib/storyblok/blocks/fullscreenVideoLink.svelte'),
	benefit_overlay: import('$lib/storyblok/blocks/benefitOverlay.svelte'),
	benefit_overlay_teaser: import('$lib/storyblok/blocks/benefitOverlayTeaser.svelte'),
	food_card: import('$lib/storyblok/blocks/foodCard.svelte'),
	landing_page_faq_container: import('$lib/storyblok/blocks/faqContainer.svelte'),
	landing_page_faq_item: import('$lib/storyblok/blocks/faqItem.svelte'),
	faq_container: import('$lib/storyblok/blocks/faqContainer.svelte'),
	faq_item: import('$lib/storyblok/blocks/faqItem.svelte'),
	tech_specs_carousel: import('$lib/storyblok/blocks/techSpecsCarousel.svelte'),
	tech_sheet: import('$lib/storyblok/blocks/techSheet.svelte'),
	tech_sheet_item: import('$lib/storyblok/blocks/techSheetItem.svelte'),
	tech_sheet_box_item: import('$lib/storyblok/blocks/techSheetBoxItem.svelte'),
	landing_page_river_expandable_text: import(
		'$lib/storyblok/blocks/landingPageRiverExpandableText.svelte'
	),
	landing_page_river_card: import('$lib/storyblok/blocks/landingPageRiverCard.svelte'),
	landing_page_river_card_container: import(
		'$lib/storyblok/blocks/landingPageRiverCardContainer.svelte'
	),
	landing_page_river_module: LandingPageRiverModule,
	landing_page_testimonials_container: import(
		'$lib/storyblok/blocks/landingPageTestimonialsContainer.svelte'
	),
	landing_page_testimonial_card: import('$lib/storyblok/blocks/landingPageTestimonialCard.svelte'),
	landing_page_comparison_table: import('$lib/storyblok/blocks/landingPageComparisonTable.svelte'),
	landing_page_comparison_table_row: import(
		'$lib/storyblok/blocks/landingPageComparisonTableRow.svelte'
	),
	landing_page_step_container: import('$lib/storyblok/blocks/landingPageStepContainer.svelte'),
	landing_page_step_container_item: import(
		'$lib/storyblok/blocks/landingPageStepContainerItem.svelte'
	),
	landing_page_step_container_v2: import('$lib/storyblok/blocks/landingPageStepContainerV2.svelte'),
	landing_page_step_container_item_v2: import(
		'$lib/storyblok/blocks/landingPageStepContainerItemV2.svelte'
	),
	landing_page_ribbon_banner: import('$lib/storyblok/blocks/landingPageRibbonBanner.svelte'),
	landing_page_ribbon_banner_item: import(
		'$lib/storyblok/blocks/landingPageRibbonBannerItem.svelte'
	),
	landing_page_pricing_module: import('$lib/storyblok/blocks/landingPagePricingModule.svelte'),
	landing_page_pricing_card: import('$lib/storyblok/blocks/landingPagePricingCard.svelte'),
	landing_page_pricing_card_affirm: import(
		'$lib/storyblok/blocks/landingPagePricingCardAffirm.svelte'
	),
	legal_text: import('$lib/storyblok/blocks/legalText.svelte'),
	cta_module: CtaModule,
	background_color: import('$lib/storyblok/blocks/backgroundColor.svelte'),
	yotpo_reviews_carousel: import('$lib/storyblok/blocks/yotpoReviewsCarousel.svelte'),
	icon_with_text: import('$lib/storyblok/blocks/iconWithText.svelte'),
	yotpo_reviews_rating: YotpoReviewsRating,
	horizontal_line: import('$lib/storyblok/blocks/horizontalLine.svelte'),
	generic_text: GenericText,
	referral_card: ReferralCard,
	benefit_image_with_text: import('$lib/storyblok/blocks/benefitImageWithText.svelte'),
	geolocation_block: GeolocationBlock,
	newsletter_banner: import('$lib/storyblok/blocks/newsletterBanner.svelte'),
	link_collection: import('$lib/storyblok/blocks/footer/linkCollection.svelte'),
	site_banner: SiteBanner,
	cta_banner: CtaBanner,
	value_prop_grid: ValuePropGrid,
	cart_value_props: CartValueProps,
	value_prop: ValueProp,
	accordion_gallery: AccordionGallery,
	accordion_gallery_card: AccordionGalleryCard,
	verified_reviews: VerifiedReviews,
	editorial_spotlight: EditorialSpotlight,
	spotlight_quote: SpotlightQuote,
	highlight_slideshow: HighlightSlideshow,
	highlight_slideshow_item: HighlightSlideshowItem,
	product_banner: ProductBanner,
	customer_reviews: CustomerReviews,
	award_banner: AwardBanner,
	benefits_bento: BenefitsBento,
	bento_info_card: BentoInfoCard,
	tolstoy_video: import('$lib/storyblok/blocks/tolstoyVideo.svelte'),
	text_split: TextSplit,
	product_cta_module: ProductCtaModule,
	fullbleed_gallery: FullbleedGallery,
	hero_fullbleed: HeroFullbleed,
	hero_floating_video: HeroFloatingVideo,
	hero_side_by_side: HeroSideBySide,
	hero_side_by_side_stacked: HeroSideBySideStacked,
	hero_press_banner: HeroPressBanner,
	press_banner_item: HeroPressBannerItem,
	hero_primary_button: ButtonHeroPrimary,
	hero_secondary_button: ButtonHeroSecondary,
	local_offer_hero: LocalOfferHero,
	quote_carousel: QuoteCarousel,
	quote_carousel_item: QuoteCarouselItem,
	partner_spotlight: PartnerSpotlight,
	local_impact: LocalImpact,
	local_offer_entry: LocalOfferEntry,
	no_local_offer_modal: NoLocalOfferModal,
	general_impact: GeneralImpact,
	pay_as_you_throw: PayAsYouThrow,
	waste_education: WasteEducation,
	simple_link: SimpleLink,
	custom_payment_messaging_element: CustomPaymentMessagingElement,
	how_it_works_simple: HowItWorksSimple,
	how_it_works_simple_item: HowItWorksSimpleItem,
	homepage_latest_stories: LatestStories,
	navigation_expand: NavigationExpand,
	nav_link_highlight: NavLinkHighlight,
	nav_link_standard: NavLinkStandard,
	nav_teaser_card: NavTeaserCard,
	nav_menu_bar_link: NavMenuBarLink,
	single_step_quiz: import('$lib/storyblok/blocks/quiz/singleStepQuiz.svelte'),
	quiz_step_single_select: import('$lib/storyblok/blocks/quiz/quizStepSingleSelect.svelte'),
	quiz_step_single_select_answer: import(
		'$lib/storyblok/blocks/quiz/quizStepSingleSelectAnswer.svelte'
	),
	quiz_step_submit_email: import('$lib/storyblok/blocks/quiz/quizStepSubmitEmail.svelte'),
	quiz_single_step_result: import('$lib/storyblok/blocks/quiz/quizSingleStepResult.svelte'),
	quiz_single_step_result_option: import(
		'$lib/storyblok/blocks/quiz/quizSingleStepResultOption.svelte'
	),
	quiz_coupon_code_result: import('$lib/storyblok/blocks/quiz/quizCouponCodeResult.svelte'),
	quiz_coupon_code_result_option: import(
		'$lib/storyblok/blocks/quiz/quizCouponCodeResultOption.svelte'
	),
	product_selector: ProductSelector,
	product_selector_item: ProductSelectorItem,
	active_product_wrapper: ActiveProductWrapper,
	active_product_subline: ActiveProductSubline,
	benefits_box: BenefitsBox,
	benefits_box_item: BenefitsBoxItem,
	feature_container: FeatureContainer,
	competitor_table: CompetitorTable,
	feature_image_gallery: import('$lib/storyblok/blocks/featureImageGallery.svelte'),
	feature_image_gallery_item: import('$lib/storyblok/blocks/featureImageGalleryItem.svelte'),
	fullbleed_asset: FullbleedAsset,
	dynamic_stats: DynamicStats,
	image_cta_banner: ImageCtaBanner,
	ratings_intro: RatingsIntro,
	wall_of_love_extended: WallOfLoveExtended,
	instagram_video_card: InstagramVideoCard,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
} satisfies Record<string, StoryblokComponent<any, any, any>>;
